import { render } from "./UIChat.vue?vue&type=template&id=39668772&scoped=true"
import script from "./UIChat.vue?vue&type=script&lang=js"
export * from "./UIChat.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-39668772"

export default script